import { BigButton } from "../../shared/components/BigButton";
import { BigButtonColor } from "../../shared/types/bigButtonProps";

export const WrongNetworkMainButton = () => (
  <BigButton color={BigButtonColor.GRAY} disabled>
    Wrong Network
  </BigButton>
);
